import { v4 } from 'uuid'

import http from './http'

export const createUserImageFormData = fileEvent => {
  const file = fileEvent.target.files[0]

  if (file.size > 204800) throw new Error('Imagem muito grande')
  const fileName = v4()
  const formData = new FormData()

  formData.append('attachment', file, fileName)

  return formData
}

export const uploadImage = (formData) => {
  return http.post('/images/upload', formData, {
    headers: { 'content-type': 'multipart/form-data' }
  })
    .then(res => res.data.data)
}
